import type { Finger } from '../../types';

export const FINGER_NAMES: Record<Finger, string> = {
  L5: 'Venstre lillefinger',
  L4: 'Venstre ringfinger',
  L3: 'Venstre langfinger',
  L2: 'Venstre pegefinger',
  L1: 'Venstre pegefinger',
  R1: 'Højre pegefinger',
  R2: 'Højre pegefinger',
  R3: 'Højre langfinger',
  R4: 'Højre ringfinger',
  R5: 'Højre lillefinger',
  thumb: 'Tommelfinger',
};

export const FINGER_COLORS: Record<Finger, string> = {
  L5: 'bg-rose-400',
  L4: 'bg-orange-400',
  L3: 'bg-amber-400',
  L2: 'bg-lime-400',
  L1: 'bg-emerald-400',
  R1: 'bg-teal-400',
  R2: 'bg-sky-400',
  R3: 'bg-indigo-400',
  R4: 'bg-violet-400',
  R5: 'bg-pink-400',
  thumb: 'bg-zinc-300',
};
